<template>
  <div v-if="!loading">
    <form>
      <v-layout
        wrap
        align-center
        justify-space-between
      >
        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.latkove_nelatkove_zavislosti"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.latkove_nelatkove_zavislosti"
            label="Látkové a nelátkové závislosti"
            name="Látkové a nelátkové závislosti"
            :error-messages="errors.collect('Látkové a nelátkové závislosti')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('latkove_nelatkove_zavislosti')"
          />
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.sudom_nariadena_liecba"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.sudom_nariadena_liecba"
            label="Súdom nariadená ochranná liečba"
            name="Súdom nariadená ochranná liečba"
            :error-messages="errors.collect('Súdom nariadená ochranná liečba')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('sudom_nariadena_liecba')"
          />
        </v-flex>
      </v-layout>

      <v-layout
        wrap
        align-center
        justify-space-between
      >
        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.absolvovanie_nariadenej_liecby"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.absolvovanie_nariadenej_liecby"
            label="Absolvovanie súdom nariadenej ochrannej liečby"
            name="Absolvovanie súdom nariadenej ochrannej liečby"
            :error-messages="
              errors.collect('Absolvovanie súdom nariadenej ochrannej liečby')
            "
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('absolvovanie_nariadenej_liecby')"
          />
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.pocet_typov_nariadenej_liecby"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.pocet_typov_nariadenej_liecby"
            label="Počet typov súdom nariadenej ochrannej liečby"
            name="Počet typov súdom nariadenej ochrannej liečby"
            :error-messages="
              errors.collect('Počet typov súdom nariadenej ochrannej liečby')
            "
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('pocet_typov_nariadenej_liecby')"
          />
        </v-flex>
      </v-layout>

      <v-layout
        wrap
        align-center
        justify-space-between
      >
        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.prevladajuci_typ_spravanie"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.prevladajuci_typ_spravanie"
            label="Prevládajúci typ správania vo vtos"
            name="Prevládajúci typ správania vo vtos"
            :error-messages="
              errors.collect('Prevládajúci typ správania vo vtos')
            "
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('prevladajuci_typ_spravanie')"
          />
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.emocionalna_stabilita"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.emocionalna_stabilita"
            label="Emocionálna stabilita (aktuálny stav vo VTOS)"
            name="Emocionálna stabilita (aktuálny stav vo VTOS)"
            :error-messages="
              errors.collect('Emocionálna stabilita (aktuálny stav vo VTOS)')
            "
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('emocionalna_stabilita')"
          />
        </v-flex>
      </v-layout>

      <v-select
        v-model="form.uroven_mentalnych_schopnosti"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.uroven_mentalnych_schopnosti"
        label="Orientačné určenie pásma úrovne mentálnych schopností"
        name="Orientačné určenie pásma úrovne mentálnych schopností"
        :error-messages="
          errors.collect(
            'Orientačné určenie pásma úrovne mentálnych schopností'
          )
        "
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('uroven_mentalnych_schopnosti')"
      />

      <v-select
        v-model="form.postoj_trestnej_cinnosti"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.postoj_trestnej_cinnosti"
        label="Postoj k trestnej činnosti"
        name="Postoj k trestnej činnosti"
        :error-messages="errors.collect('Postoj k trestnej činnosti')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('postoj_trestnej_cinnosti')"
      />

      <v-select
        v-model="form.specificka_porucha_osobnosti"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.specificka_porucha_osobnosti"
        label="Špecifická porucha osobnosti"
        name="Špecifická porucha osobnosti"
        :error-messages="errors.collect('Špecifická porucha osobnosti')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('specificka_porucha_osobnosti')"
      />

      <v-select
        v-model="form.psychoticke_ochorenia"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.psychoticke_ochorenia"
        label="Psychotické ochorenia"
        name="Psychotické ochorenia"
        :error-messages="errors.collect('Psychotické ochorenia')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('psychoticke_ochorenia')"
      />

      <v-layout
        row
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader
            class="pl-0"
          >
            Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa
            dopustí trestnej činnosti do 2 rokov od prepustenia
          </v-subheader>
          <v-slider
            v-model="form.expertne_posudenie"
            :tick-labels="selects.expertne_posudenie"
            always-dirty
            min="1"
            max="3"
            ticks="always"
            :color="color"
            :readonly="form.closed"
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('expertne_posudenie')"
          />
        </v-flex>
      </v-layout>

      <v-divider class="mt-10" />

      <v-textarea
        v-model="form.poznamky"
        :disabled="form.closed"
        label="Poznámky a doplňujúce informácie"
        auto-grow
        rows="1"
      />

      <v-select
        v-model="form.nepravdive_zavadzajuce"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.nepravdive_zavadzajuce"
        label="Nepravdivé/zavádzajúce informácie"
        name="Nepravdivé/zavádzajúce informácie"
        :error-messages="errors.collect('Nepravdivé/zavádzajúce informácie')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('nepravdive_zavadzajuce')"
      />

      <v-divider class="mt-10" />

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="red"
          @click="closeItem"
        >
          Uložiť a uzatvoriť
        </v-btn>
      </v-layout>
      <v-layout
        v-else
        pt-5
      >
        <div class="flex-grow-1" />
        <v-btn
          v-if="!craItem.closed"
          dark
          color="green"
          @click="openItem"
        >
          Otvoriť
        </v-btn>
      </v-layout>
    </form>
    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <tooltip-component
        :dialog_item="dialog_item"
        :on_close="closeTooltipDialog"
      />
    </v-dialog>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="complex" />
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import { Tooltips } from "@/assets/tooltips";
import TooltipComponent from "./TooltipComponent.vue";
import FormSkeleton from "../../components/FormSkeleton.vue";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();
const tooltips = new Tooltips();

export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    "tooltip-component": TooltipComponent,
    "form-skeleton-component": FormSkeleton,
  },
  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: [],
    },

    form: {
      id: null,
      latkove_nelatkove_zavislosti: "",
      sudom_nariadena_liecba: "",
      absolvovanie_nariadenej_liecby: "",
      pocet_typov_nariadenej_liecby: "",
      prevladajuci_typ_spravanie: "",
      emocionalna_stabilita: "",
      uroven_mentalnych_schopnosti: "",
      postoj_trestnej_cinnosti: "",
      specificka_porucha_osobnosti: "",
      psychoticke_ochorenia: "",
      expertne_posudenie: "1",
      nepravdive_zavadzajuce: "",
    },

    craItem: {},

    selects: {
      latkove_nelatkove_zavislosti: [
        "správanie odsúdeného vykazuje znaky závislosti",
        "správanie odsúdeného nevykazuje znaky závislosti",
      ],
      sudom_nariadena_liecba: [
        "odsúdenému bola súdom nariadená ochranná liečba",
        "odsúdenému bola súdom nariadená ochranná liečba opakovane",
        "odsúdenému nebola súdom nariadená ochranná liečba",
      ],
      absolvovanie_nariadenej_liecby: [
        "odsúdený absolvoval súdom nariadený typ/y ochrannej liečby",
        "odsúdený neabsolvoval súdom nariadený typ/y ochrannej liečby",
        "odsúdenému nebola súdom nariadená ochranná liečba",
      ],
      pocet_typov_nariadenej_liecby: [
        "žiadny",
        "1 typ",
        "2 typy",
        "3 typy a viac",
      ],
      prevladajuci_typ_spravanie: ["asertívny", "pasívny", "agresívny"],
      emocionalna_stabilita: [
        "odsúdený je emocionálne stabilný",
        "odsúdený nie je emocionálne stabilný",
      ],
      uroven_mentalnych_schopnosti: [
        "mentálna retardácia",
        "podpriemer",
        "priemer",
        "nadpriemer",
      ],
      postoj_trestnej_cinnosti: [
        "kritický - zodpovednosť voči TČ s vedomím kompetencie meniť svoje správanie / postoje",
        "nekritický - zodpovednosť za TČ odmieta alebo prenáša na ostatných, na okolnosti, cíti sa ako obeť a pod.",
      ],
      specificka_porucha_osobnosti: [
        "odsúdený vykazuje znaky špecifickej poruchy osobnosti",
        "odsúdený nevykazuje znaky špecifickej poruchy osobnosti",
      ],
      psychoticke_ochorenia: [
        "odsúdený vykazuje znaky psychotického ochorenia",
        "odsúdený nevykazuje znaky psychotického ochorenia",
      ],
      expertne_posudenie: ["malá", "stredná", "vysoká"],
      nepravdive_zavadzajuce: [
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený UVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený NEUVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
      ],
    },

    manual: tooltips.psychologickeVysetrenie,
  }),

  computed: {
    color() {
      if (this.form.expertne_posudenie == 0) return "grey";
      if (this.form.expertne_posudenie == 1) return "green";
      if (this.form.expertne_posudenie == 2) return "orange";
      if (this.form.expertne_posudenie == 3) return "red";
      return "grey";
    },
  },

  created() {
    this.getPsychologickeVysetrenie();
  },

  methods: {
    closeTooltipDialog() {
      this.dialog = false;
    },

    appendIconCallback(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },

    clear() {
      this.form.id = null;
      this.form.latkove_nelatkove_zavislosti = "";
      this.form.sudom_nariadena_liecba = "";
      this.form.absolvovanie_nariadenej_liecby = "";
      this.form.pocet_typov_nariadenej_liecby = "";
      this.form.prevladajuci_typ_spravanie = "";
      this.form.emocionalna_stabilita = "";
      this.form.uroven_mentalnych_schopnosti = "";
      this.form.postoj_trestnej_cinnosti = "";
      this.form.specificka_porucha_osobnosti = "";
      this.form.psychoticke_ochorenia = "";
      this.form.expertne_posudenie = "1";
      this.skore = 0;
    },
    getPsychologickeVysetrenie() {
      this.loading = true;
      var numberOfItemsToLoad = 2;
      apiService
        .getPsychologickeVysetrenie(this.$route.params.id)
        .then((response) => {
          this.form = response;
          numberOfItemsToLoad--;
          if (numberOfItemsToLoad == 0) {
            this.loading = false;
          }
        });
      apiService.getCraForm(this.$route.params.id).then((response) => {
        this.craItem = response;
        numberOfItemsToLoad--;
        if (numberOfItemsToLoad == 0) {
          this.loading = false;
        }
      });
    },
    updateItem() {
      apiService
        .updatePsychologickeVysetrenie(this.form, this.$route.params.id)
        .then(
          () => {
            this.snackbar_saved = true;
            this.$root.$emit("ecra_part_updated");
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },
    openItem() {
      apiService
        .updatePsychologickeVysetrenie(
          { id: this.form.id, closed: false },
          this.$route.params.id
        )
        .then(
          (response) => {
            this.snackbar_saved = true;
            this.form = response;
            this.$root.$emit("ecra_part_updated");
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },

    closeItem() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť túto časť formulára? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;

            apiService
              .updatePsychologickeVysetrenie(this.form, this.$route.params.id)
              .then(
                (response) => {
                  this.snackbar_saved = true;
                  this.form = response;
                  this.$root.$emit("ecra_part_updated");
                },
                () => {
                  this.snackbar_error = true;
                }
              );
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    },
  },
};
</script>